export default "__VITE_ASSET__c8b521df__"